// 图书
const bookRouter = [{
  path: '/book',
  name: 'Book',
  component: () => import('@/views/book/index')
},{
  path: '/bookInfo',
  name: 'BookInfo',
  component: () => import('@/views/book/bookInfo')
}]
export default bookRouter
